export default "__VITE_ASSET__D796C4vA__"